/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { connect }          from 'react-redux';
import { closeMenu }        from '../../store/actions';
import { NavigationAnchor } from '../../components/molecules/NavigationAnchor';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    onAnchorClick: () => dispatch(closeMenu())
});

export const NavigationLink = connect(mapStateToProps, mapDispatchToProps)(NavigationAnchor);



// WEBPACK FOOTER //
// ./src/containers/NavigationLink/index.js